// components/Announcements/index.js

import Announcements from './Announcements';

export default Announcements;
